<template>
  <v-container grid-list-md pa-0>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion" v-html="textSpanish"></p>
        <div class="e-chat">
          <div class="e-chat-content mt-3">
            <div class="e-chat-content-left">
              <div v-html="textMessage2"></div><br/>
              <small class="grey-light--text pt-2 d-inline-block"></small>
            </div>
            <div class="e-chat-content-right mt-3 text-xs-right">
              <div class="white--text" v-html="textMessage1"></div><br/>
              <small class="grey-light--text pt-2 d-inline-block"></small>
            </div>
          </div>
          <div></div>
        </div>
        <div class="e-ejercicio-descripcion-ejemplo mb-4 mt-3" v-html="textExercise"></div>
      </div>
      <div class="e-ejercicio-ejercicio  pt-0">
        <v-layout pt-0 row>
          <SubCardColumna v-for="(option, index) in options"
          :key="`textCol-${index}`"
          :respuesta="option"
          @clicked="respuestaSelected"/>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>
<script>
import SubCardColumna from '../../../components/Practica/basica/SubCardColumna'

export default {
  name: 'practicaSeleccionarColumna',
  props: {
    textSpanish: {
      type: String,
      default: ''
    },
    textExercise: {
      type: String,
      default: ''
    },
    textMessage1: {
      type: String,
      default: ''
    },
    textMessage2: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    answer: {
      type: String
    }
  },
  data() {
    return {
      respuestas: []
    }
  },
  components: {
    SubCardColumna
  },
  methods: {
    respuestaSelected (values) {
        if(values.selected){
            this.respuestas.push(values.value)
        } else {
            this.respuestas = this.respuestas.filter( value => value !== values.value )
        }
        const respuestaFinal = {
        answer: this.answer,
        userAnswer: this.respuestas
        }
        this.$emit('clicked', respuestaFinal)
    }
  }
}
</script>
